import React, {Component} from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import {Spinner} from 'react-bootstrap';
import BreadcrumbCustomer from "../../Layout/user/BreadcrumbCustomer";
import {FaCloud} from "react-icons/fa";
import { Card, CardBody } from 'reactstrap';

class AdminExportExcelByVpsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            btnSubmit: false,
            loadPage: true,
            isLoading: true,
            listService: [],
            error: false,
            messageError: '',
            email: '',
            checkEmail: false,
            userChange: {},
            errorForm: false,
            messageForm: '',
            name: '',
            ip: true,
            config: true,
            due_date: true,
            password: true,
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getDetailListVps( this.props.listVpsId );
    }

    getDetailListVps = (listVpsId) => {
        this.setState({
            loadPage: true,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        axios.get( process.env.REACT_APP_API_URL + '/api/admin/vps/getDetailListVpsExport?listVpsId=' + listVpsId,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listService: ref.data.content,
                        loadPage: false,
                        error: false,
                        messageError: '',
                    })
                } else {
                    if ( ref.data.error > 9000 ) {
                        this.props.logOut();
                    }
                    else if ( ref.data.error > 8000 ) {
                        this.redirectBack(ref.data.message);
                    }
                    else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                            loadPage: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                this.setState({
                    loadPage: false,
                    error: true,
                    messageError: 'Lấy dữ liệu VPS thất bại',
                })
            })
    }

    btnRedirectBack = () => {
        this.props.redirectBack();
    }

    redirectBack = (message) => {
        this.props.updateErrorNotiUser({
            error: true,
            message: message
        });
        this.props.redirectBack();
    }

    redirectSuccess = (message) => {
        this.props.updateSuccessNotiUser({
            success: true,
            message: message
        });
        this.props.redirectBack();
    }

    changeInput = (event) => {
        this.setState({
            [event.target.name]: event.target.type === 'checkbox' ? event.target.checked : event.target.value
        })
    }

    submit = () => {
        this.setState({
            loadPage: true,
            btnSubmit: true,
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let form = {
            listVpsIp: this.props.listVpsId,
            file_name: this.state.name,
            ip: this.state.ip,
            config: this.state.config,
            due_date: this.state.due_date,
            password: this.state.password,
        };
        // console.log(form);
        axios.put( process.env.REACT_APP_API_URL + '/api/admin/vps/exportExcelVps', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( async (ref) => {
                if (ref.data.error === 0) {
                    this.setState({
                        loadPage: false,
                        btnSubmit: false,
                    });
                    let a = document.createElement('a');
                    a.href = process.env.REACT_APP_API_URL + ref.data.content;
                    a.download = process.env.REACT_APP_API_URL + ref.data.file_name;
                    await document.body.append(a);
                    await a.click();
                    await a.remove();

                    await this.DeleteFile(ref.data.delete);
                } else {
                    if (ref.data.error > 9000) {
                        this.props.logOut();
                    } else if (ref.data.error > 8000) {
                        this.redirectBack(ref.data.message);
                    } else {
                        this.setState({
                            btnSubmit: false,
                            errorForm: true,
                            messageForm: ref.data.message,
                            loadPage: false,
                            checkEmail: false,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( () => {
                this.setState({
                    loadPage: false,
                    checkEmail: false,
                    errorForm: true,
                    btnSubmit: false,
                    messageForm: 'Truy vấn dữ liệu thất bại',
                })
            })
    }

    DeleteFile = (deleteId) => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let form = {
            url: deleteId
        };
        axios.put( process.env.REACT_APP_API_URL + '/api/vps/removeExportExcelVps', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
        return true;
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary"/>
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Xuất FILE EXCEL"} page={"VPS"} icon={<FaCloud className="breadcrumb-icon"/>}/>
                            <Card className="card-change-user">
                                <CardBody>
                                    {
                                        this.state.error ? (
                                            <Alert color="danger">
                                                { this.state.messageError }
                                            </Alert>
                                        ) : (
                                            <div className="m-4">
                                                <div className="form-group row">
                                                    <div className="col-md-12 text-center">
                                                        {
                                                            this.state.errorForm ? (
                                                                <Alert color="danger">
                                                                    { this.state.messageForm }
                                                                </Alert>
                                                            ) : (
                                                                <></>
                                                            )
                                                        }
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <h5>Danh sách VPS:</h5>
                                                        <div className="col-md-3">
                                                            {
                                                                this.state.listService.map( (vps, key) => (
                                                                    <div key={key}>
                                                                        <b>{key+1}. </b> { vps.ip }
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="name">Tên file</label>
                                                    <input type="text" placeholder="Tên file"
                                                           name="name" id="name" className="form-control"
                                                           onChange={ this.changeInput }
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="">Chọn thuộc tính xuất excel</label>
                                                    <div className="form-check">
                                                        <input className="form-check-input" name="ip" value="1"
                                                               type="checkbox" onChange={ this.changeInput }
                                                               checked={ this.state.ip }
                                                        />
                                                        <label className="form-check-label">Địa chỉ IP</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input className="form-check-input" name="config" value="1"
                                                               type="checkbox"  onChange={ this.changeInput }
                                                               checked={ this.state.config } />
                                                        <label className="form-check-label">Cấu hình</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input className="form-check-input" name="due_date" value="1"
                                                               type="checkbox"  onChange={ this.changeInput }
                                                               checked={ this.state.due_date } />
                                                        <label className="form-check-label">Ngày kết thúc</label>
                                                    </div>
                                                    <div className="form-check">
                                                        <input className="form-check-input" name="password" value="1"
                                                               type="checkbox"  onChange={ this.changeInput }
                                                               checked={ this.state.password } />
                                                        <label className="form-check-label">Mật khẩu</label>
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <div className="col-md-12 text-center">
                                                        <button className="btn btn-default mr-1"
                                                                onClick={ () => this.btnRedirectBack() }
                                                        >
                                                            Quay lại
                                                        </button>
                                                        <button className="btn btn-primary ml-1"
                                                                onClick={ () => this.submit() }
                                                                disabled={ this.state.btnSubmit }
                                                        >
                                                            Xác nhận
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                </CardBody>
                            </Card>
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'AdminExportExcel' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
        updateSuccessNotiUser: (item) => {
            dispatch(({ type : 'updateSuccessNotiUser', item }))
        },
        updateErrorNotiUser: (item) => {
            dispatch(({ type : 'updateErrorNotiUser', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminExportExcelByVpsComponent);